module.exports = __webpack_public_path__ + "static/media/hab1-1.57f258f1.jpg";